import { Service } from "models/Service";
import { getDataAgendaLila, filterDataAgendaLila } from "helpers";

const pagegrowlerFrontendApiUrl = process.env.PAGEGROWLER_FRONTEND_API ?? process.env.NEXT_PUBLIC_PAGEGROWLER_FRONTEND_API;

export class SportsCalendar extends Service {
  constructor() {
    const today = new Date();
    const options = { day: 'numeric', month: 'long' };
    const formattedDate = today.toLocaleDateString('es-ES', options);
    
    super({
      adsPath: "servicios/home",
      meta: {
        description: `Calendario de eventos deportivos, programación y resultados de partidos en vivo con actualización en directo, próximos partidos, fixtures y dónde ver en TV - Clarin.com`,
        keywords: 'Programación deportiva, Agenda deportiva, calendario deportivo, Agenda del día, Partidos de hoy',
        title: `Agenda deportiva y todos los partidos de hoy, ${formattedDate} | Clarin.com`,
        url: `deportes/agenda-deportiva`,
        urlImage: "https://www.clarin.com/img/deportes/agenda_deportiva_share.webp",
        extra: [],
      },
      section: "deportes",
      sectionName: "Deportes",
      template: "SportsCalendar",
      title: `Agenda deportiva y todos los partidos de hoy, ${formattedDate}`,
      widthFull: false,
      slug: "deportes/agenda-deportiva/",
      titleHeader: `Agenda deportiva y todos los partidos de hoy, ${formattedDate}`,
      customNewsToday: false
    });    
  }
  
  parseData = async (match,menu,query) => {
    const slug = "deportes";
    //const notes = await this.fetchData(`${process.env.LILAX_FRONTEND_API}latest/?type=lilanews&tag=${slug}&limit=6`);
    const notes = await this.fetchData(`${pagegrowlerFrontendApiUrl}lilanews/?type=listType&tag=${slug}&limit=6`);
    const parseUrl = match.join('/')
    this.setSlug(parseUrl);
    this.setData({
      notes: notes?.data?.content ?? [],
    });

    const setNewsToday = (key) => {
      const newsToday = menu?.[key]?.item?.items ?? [];
      Array.isArray(newsToday) && this.setCustomNewsToday(newsToday);
    };

    switch (match?.[1]) {
      case "futbol-masculino-juegos-panamericanos-2023-santiago-chile-fixture-resultados":
        this.setTemplate("PanamericanGames");
        this.setTitleHeader(`Futbol masculino`);
        this.setTitle(`Futbol masculino | Juegos Panamericanos 2023: fixture y resultados de las selecciones en Santiago de Chile`);
        this.setWidthFull(true);
        this.setMeta(this.parseMeta({ 
          description: `Tabla, fixture, resultados y próximo partidos del fútbol masculino en los Juegos Panamericanos en Chile 2023.`, 
          keywords: "juegos panamericanos, futbol", 
          title: `Futbol masculino | Juegos Panamericanos 2023: fixture y resultados de las selecciones en Santiago de Chile`, 
          url: parseUrl, 
          extra: [] 
        }));
        this.setData({
          iframe: "https://gamecenter.clarin.com/v3/index.html?channel=deportes.futbol.futbolmascpan.fixture&lang=es_LA",
          height: "550",
          notes: notes?.data?.content ?? [],
        });
        break;
      case "futbol-femenino-juegos-panamericanos-2023-santiago-chile-seleccion-argentina-fixture-resultados":
        this.setTemplate("PanamericanGames");
        this.setTitleHeader(`Futbol femenino`);
        this.setTitle(`Futbol femenino | Juegos Panamericanos 2023: fixture y resultados de la Selección Argentina en Santiago de Chile`);
        this.setWidthFull(true);
        this.setMeta(this.parseMeta({ 
          description: `Tabla, fixture, resultados y próximo partidos de la Selección Argentina de fútbol Femenino en los Juegos Panamericanos en Chile 2023.`, 
          keywords: "juegos panamericanos, futbol", 
          title: `Fútbol femenino | Juegos Panamericanos 2023: fixture y resultados de la Selección Argentina en Santiago de Chile`, 
          url: parseUrl, 
          extra: [] 
        }));
        this.setData({
          iframe: "https://gamecenter.clarin.com/v3/index.html?channel=deportes.futbol.futbolfempan&lang=es_LA",
          height: "550",
          notes: notes?.data?.content ?? [],
        });
        break;
      case "juegos-panamericanos-2023-santiago-chile-medallero-resultados-posiciones":
        this.setTemplate("PanamericanGames");
        this.setTitleHeader(`Medallero y resultados`);
        this.setTitle(`Medallero y resultados | Juegos Panamericanos 2023: todas las posiciones y quién lidera la tabla del torneo`);
        this.setWidthFull(true);
        this.setMeta(this.parseMeta({ 
          description: `El medallero y las últimas noticias de Argentina y el resto de países que compiten en los Juegos Panamericanos en Chile 2023.`, 
          keywords: "juegos panamericanos, futbol", 
          title: `Medallero y resultados | Juegos Panamericanos 2023: todas las posiciones y quién lidera la tabla del torneo`, 
          url: parseUrl, 
          extra: [] 
        }));
        this.setData({
          iframe: "https://gamecenter.clarin.com/jjpp/es/medallero.html",
          height: "1000",
          notes: notes?.data?.content ?? [],
        });
        break;
      case "agenda-deportiva":
        this.setTemplate("AgendaDeportiva");
        this.setTitleHeader("Agenda deportiva");
        this.setWidthFull(false);
        this.setMeta(this.parseMeta({
          description: "Consulta el calendario de eventos deportivos de Argentina y el mundo. Sigue de cerca los partidos clave de la Copa Libertadores, Champions League, UEFA, NBA, NFL, Fórmula 1 y más. No te pierdas ninguna de las competiciones más importantes del fútbol, tenis, básquet, automovilismo y otros deportes.",
          keywords: "eventos deportivos Argentina, calendario deportivo mundial, partidos de fútbol hoy, agenda Copa Libertadores, UEFA Nations, calendario Champions League, NBA partidos en vivo, NFL, MLS, torneos de tenis, agenda Fórmula 1 2024, competiciones deportivas internacionales, fútbol, tenis, básquet y automovilismo, calendario de deportes online.",
          title: `Agenda Deportiva | Clarín`,
          url: parseUrl,
          extra: []
        }));
        const data = await getDataAgendaLila(query);
        // filtramos eventos donde pasaron +3hs desde la fecha de inicio
        const datesFilter = filterDataAgendaLila(data?.fechas ?? [])
        this.setData({
            dates: datesFilter,
            today: data?.hoy ?? "",
            firma: [
              {
                name: "Mercado, Joaquín",
                mail: "jtmercado@agea.com.ar"
              },
              {
                name: "Medina, Valentina Magalí",
                mail: "valmedina@agea.com.ar"
              },
              {
                name: "Rubio Laucella, Santiago Tomás",
                mail: "srubio@agea.com.ar"
              }
            ],

        });
        // customizamos el news today
        setNewsToday("deportes-temas-del-dia");
        
        break;
    }
  }
}